import React, { Component } from 'react'; 
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
import _ from 'lodash';
export default class DropDown extends Component {
  constructor(props){
    super(props)
    this.state ={
      [props.object.labelObj]:[]
    }
  }
  handleDropDown = (obj, labelVal) => {
    this.setState({[labelVal]:obj})
    this.props.onCallBack(obj);
  }
 
  
  render(){
    const{object, readOnly, multiple, options} = this.props; 
    let opVal =[]
    _.map(options, (obj) =>{
      if(obj['status']  !== 'INACTIVE'){
        opVal.push(obj)
      }
    })
    let labelVal = object.labelObj;
    let selected = {}
    if(readOnly){
      selected = this.props.selected
    } else {
      selected = this.state[labelVal]
    }
    return(
      <div>
        <b>{labelVal}</b>
        <Picky keepOpen={false}
        value={selected}
        options={opVal}
        onChange={(e)=>this.handleDropDown(e, labelVal)}
        open={false}
        valueKey="label"
        labelKey="label"
        multiple={multiple}
        includeSelectAll={multiple}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select'
        dropdownHeight={600}
        />
     </div>
    )
  }
}
DropDown.defaultProps = {
  multiple:true
};
